import React, { useEffect, useState } from "react";
import { Box, Text, Avatar, useDisclosure, Flex, Badge, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody,  HStack, DrawerFooter, Button, } from "@chakra-ui/react";
import { OnlineEmployeeModel } from "./model";
import { CustomTable, CustomToast } from "../../../../components";
import { useFetch } from "../../../../hooks/useFetch";
import { Column } from "../../../../components/CustomTable/customTable";


const OnlineEmployee = () => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  const [employees, setEmployees] = useState<OnlineEmployeeModel[]>([]);
  const [loading, setLoading] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const loadEmployeeAssignedBranch = async () => {
    setLoading(true);
    const response = await fetchApi("Dashboard/GetOnlineEmployees", "GET", "", "", "");
    if (response) {
      setEmployees(response);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadEmployeeAssignedBranch();
  }, []);

    // useEffect(() => {
  //   loadEmployeeAssignedBranch();

  //   const interval = setInterval(loadEmployeeAssignedBranch, 60000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>
      <Flex align="center" gap={2} bg="green.50" px={4} py={2} borderRadius="full" cursor="pointer" w="fit-content" boxShadow="sm" _hover={{ bg: "green.100" }} onClick={onOpen} >
        <Box w="8px" h="8px" bg="green.500" borderRadius="full" />
        <Text fontWeight="500">Online: {employees.length}</Text>
      </Flex>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
        <DrawerOverlay />
        <DrawerContent>

          <DrawerHeader borderBottomWidth="1px">
            <Flex justify="space-between" align="center">
              <Text fontSize="lg" fontWeight="bold"> 🟢 Online Employees </Text>

              <Badge colorScheme="green" borderRadius="full" px={3} py={1}>
                {employees.length} Active
              </Badge>
            </Flex>
          </DrawerHeader>

          <DrawerBody>

            <CustomTable value={employees} loading={loading} emptyMessage="No employees online">
              <Column
                header="Employee"
                body={(row: OnlineEmployeeModel) => (
                  <HStack spacing={3}>
                    <Box position="relative">
                      <Avatar name={row.employeeName} bg="blue.500" color="white" size="sm" />
                      <Box position="absolute" bottom="0" right="0" w="8px" h="8px" bg="green.400" borderRadius="full" border="2px solid white" />
                    </Box>

                    <Box>
                      <Text fontWeight="600" fontSize="sm"> {row.employeeName} </Text>
                      <Text fontSize="xs" color="gray.500"> {row.designationName} </Text>
                    </Box>
                  </HStack>
                )}
              />
              <Column header="Department" body={(row: OnlineEmployeeModel) => (<Text fontSize="sm">{row.departmentName}</Text>)} />
              <Column header="Company" body={(row: OnlineEmployeeModel) => (<Text fontSize="sm">{row.companyName}</Text>)} />
              <Column header="Branch" body={(row: OnlineEmployeeModel) => (<Text fontSize="sm">{row.branchName}</Text>)} />

            </CustomTable>
          </DrawerBody>
          <DrawerFooter>
              <Button onClick={onClose} colorScheme="gray" variant="outline"> Cancel </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default OnlineEmployee;


